import {
  reactQueryGet,
  reactQueryPost,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";

interface IndexParams {
  formId: number;
  params: {
    page: number;
    per_page: number;
  };
}
export interface CreateSubmissionPayload {
  elements: { id: number; value: string; value_json?: string[] }[];
  turnstile_token?: string;
}
interface CreateParams {
  formId: number;
  payload: CreateSubmissionPayload;
}

const index = ({ formId, params }: IndexParams) =>
  reactQueryGet(internalApi.submissions.index({ formId, params }));

const create = ({ formId, payload }: CreateParams) =>
  reactQueryPost(internalApi.submissions.create({ formId }), payload);

const export_csv = (formId: number) =>
  reactQueryPost(internalApi.submissions.export_csv({ formId }));

export const submissionsApi = {
  index,
  create,
  export_csv,
};
